<template>
    <ul
        ref="breadcrumbs"
        class="list-none text-slate-400 text-sm w-full max-md:line-clamp-2 truncate"
    >
        <li class="inline-flex items-center">
            <a
                class="pr-3"
                :href="baseLink"
                >{{ baseLabel }}</a
            >
            <i class="icon icon-chevron-right"></i>
        </li>
        <li
            v-for="(breadcrumb, index) in breadcrumbs"
            :key="index"
            class="inline-flex items-center"
        >
            <a
                :class="[index + 1 < breadcrumbs.length ? 'pr-3' : '']"
                :href="breadcrumb.link"
                >{{ breadcrumb.title }}</a
            >
            <i
                v-if="index + 1 < breadcrumbs.length"
                class="icon icon-chevron-right"
            ></i>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import route from '@router/route';

export default {
    name: 'Breadcrumbs',
    i18nOptions: {
        namespaces: ['common'],
    },
    props: {
        breadcrumbs: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ...mapGetters('auth', ['isLoggedIn']),
        baseLabel() {
            if (this.isLoggedIn) {
                return this.$t('breadcrumbs.dashboard');
            }
            return this.$t('breadcrumbs.home');
        },
        baseLink() {
            if (this.isLoggedIn) {
                return route('dashboard.show');
            }
            return route(`home.index`);
        },
    },
};
</script>

<style lang="scss" scoped>
li:not(:last-child) {
    @apply pr-3;
}
</style>
